export const menuItems = [
  {
    id: 1,
    label: "menuitems.dashboards.text",
    icon: "bx-home-circle bx-tada",
    link: "/",
  },
  {
    id: 2,
    isLayout: true,
  },
  {
    id: 3,
    label: "menuitems.user.text",
    icon: "bx-user bx-tada",
    link: "/user-list",
  },
  {
    id: 11,
    label: "menuitems.charger-management.text",
    icon: "bx-plug bx-tada",
    subItems: [
      {
        id: 5,
        label: "menuitems.charger-management.text",
        link: "/charger-details",
        parentId: 11,
      },
      {
        id: 2,
        label: "menuitems.charger.text",
        link: "/charger-status",
        parentId: 11,
      },
    ],
  },
  {
    id: 10,
    label: "menuitems.vehicle-management.text",
    icon: "bx-car bx-tada",
    link: "/vehicle-details",
  },
  {
    id: 7,
    label: "menuitems.status.text",
    icon: "bx bx-radio-circle bx-burst",
    subItems: [
      {
        id: 1,
        label: "menuitems.payment-status.text",
        link: "/payment-status",
        parentId: 7,
      },
    ],
  },
  {
    id: 6,
    label: "menuitems.booking.text",
    icon: "bx bxs-bell bx-tada",
    link: "/booking-list",
  },
  {
    id: 8,
    label: "menuitems.charger-history.text",
    icon: "bx bx-history bx-tada",
    link: "/charger-history",
  },
  {
    id: 15,
    label: "menuitems.wallet-history.text",
    icon: "bx bx-wallet-alt bx-tada",
    link: "/wallet-history",
  },
  {
    id: 9,
    label: "menuitems.reports.text",
    icon: "bx bx-loader bx-burst",
    subItems: [
      {
        id: 3,
        label: "menuitems.reports.ChargerReportText",
        link: "/reports",
        parentId: 9,
      },
      {
        id: 4,
        label: "menuitems.reports.UserReportText",
        link: "/user-report-details",
        parentId: 9,
      },
    ],
  },
  {
    id: 12,
    label: "menuitems.withdrawal.text",
    icon: "bx bx-wallet bx-tada",
    link: "/withdrawal-details",
  },
  {
    id: 4,
    label: "menuitems.pages.text",
    icon: "bx bx-notepad bx-tada",
    link: "/content-page-list",
  },
  {
    id: 5,
    label: "menuitems.versions.text",
    icon: "bx bxs-error bx-tada",
    link: "/version-list",
  },
  {
    id: 13,
    label: "menuitems.user_report.text",
    icon: "bx bx-message-rounded-detail bx-tada",
    link: "/user-report",
  },
  {
    id: 14,
    label: "menuitems.banner.text",
    icon: "bx bx-images bx-tada",
    link: "/banner",
  },
];
